import { useClientSaveSigningContract } from 'api/requests';
import { ClientDocumentGroupName } from 'api/types/data';
import { ClientEntity } from 'api/types/entity';

import { useClientSigningDocumentGroup } from './useClientSigningDocumentGroup';

export const useClientSigningContract = (client: ClientEntity) => {
  const {
    signingContract,
    loading: submitLoading,
    error: submitError,
  } = useClientSaveSigningContract();

  const { documents, formError, loading, onClickDocument, onSubmit } =
    useClientSigningDocumentGroup(
      client,
      ClientDocumentGroupName.ServiceContract,
      signingContract,
      submitError
    );

  return {
    documents,
    loading,
    submitLoading,
    formError,
    onClickDocument,
    onSubmit,
  };
};
